import { getEmptyDashboardData } from './myPerformanceTransformer';

/** Empty dashboard data - no hardcoded values. Use for initial/loading/error states. */
export const defaultDashboardData = getEmptyDashboardData();
